import React, { useState } from 'react';
import {
  Carousel,
  CarouselItem
} from 'reactstrap';
import ReactCompareImage from 'react-compare-image';

const BeforeAfterCarousel = (props) => {
  const [setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  const activeIndex = props.current;
  
  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === props.items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  }

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? props.items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  }

const indicators = props.items.map((thumb, i) => {
    return (
      <li data-target='#carousel-custom' data-slide-to={i} className='active'>&nbsp;</li>
      );
  });

  const slides = props.items.map((item) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.src}
      >
      <ReactCompareImage 
        leftImage={item.beforeImage.imageFile.childImageSharp.fluid.src}
        leftImageAlt={item.beforeImage.altText}
        rightImage={item.afterImage.imageFile.childImageSharp.fluid.src}
        rightImageAlt={item.afterImage.altText} />
      </CarouselItem>

    );
  });

  return (
    <Carousel
      activeIndex={activeIndex}
      next={next}
      previous={previous}
      interval={false}
    >
      {slides}
    <ol className="carousel-indicators d-none">
           {indicators}
                </ol>
    </Carousel>
  );
}

export default BeforeAfterCarousel;